import React from "react";

const PHASES = [
  {
    name: "Phase 0 · Before the case (optional)", window: "On request · ~1 business day", tone: "opt",
    steps: [
      ["0.1", "Pre-service verification if the independent sends insurance ahead of the case — informational only, never a gate; the claim-intake determination remains the record", "Ops lane", "SOP 11.4", "—"],
    ],
  },
  {
    name: "Phase 1 · Case & staffing", window: "Day 0", tone: "ops",
    steps: [
      ["1.1", "Open the case record with a unique ECH case ID (facility, procedure, state, DOS)", "Ops lane", "SOP 11.1", "Case Pipeline"],
      ["1.2", "Staff a credentialed, privileged assist (60-day credential warnings watched); confirm acceptance — eligibility is NOT a staffing gate", "Ops lane", "SOP 11.3 · 7.1/7.2", "Case Pipeline + Credential Dashboard"],
      ["1.3", "Case performed and turned in with the patient's insurance information", "Assist", "SOP 11.1", "—"],
    ],
  },
  {
    name: "Phase 2 · Documentation", window: "Within 24 hours of the case", tone: "ops",
    steps: [
      ["2.1", "Documentation package complete: op-note naming the assist and role, participation description, coding detail (AS/80/82 context), facility/surgeon identifiers, insurance capture", "Assist + Ops QC", "SOP 12.1", "Case Pipeline (docs gate; overdue flags at 24h)"],
      ["2.2", "QC against the checklist — incomplete packages return to the assist same day", "Ops QC", "SOP 12.1", "Case Pipeline"],
    ],
  },
  {
    name: "Phase 3 · Claim intake — eligibility determination (Layer 1 of 4)", window: "Monthly cycle, before the provider-payment determination", tone: "gate",
    steps: [
      ["3.1", "Run the five checks with evidence: plan type (MA trap!), facility network, state pathway (+ funding status in bifurcated states only), service billability, state law", "Ops lane", "SOP 11.2", "A-4 Intake Determination"],
      ["3.2", "Sort ACCEPTED or INELIGIBLE in the provider's ShareFile folder with the controlled reason code", "Ops lane", "SOP 11.1", "A-4 (reason codes → KPI by cause)"],
      ["3.3", "INELIGIBLE → STOP. Not billed, not disputed, absorbed by the independent. Completeness (100% sorted) is the compliance standard; the rate (~30%) is an operating metric", "—", "SOP 11.1 · MOCR A-1/A-2", "KPI Dashboard"],
    ],
  },
  {
    name: "Phase 4 · Billing handoff (accepted cases only)", window: "On QC pass", tone: "gate",
    steps: [
      ["4.1", "Hand off to the RCM partner — system rejects billing without complete documentation AND an ACCEPTED determination (Layer 2: partner re-screens; federally funded cases are not billed)", "Ops lane", "SOP 11.3 · Ch 13", "Case Pipeline (billed gate)"],
      ["4.2", "Register the claim in the Deadline Calendar the day it bills — every statutory window below is computed and watched from here", "Ops lane", "SOP 13.1 · 14.2", "Deadline Calendar"],
    ],
  },
  {
    name: "Phase 5 · Payer response", window: "60 CALENDAR days", tone: "cal",
    steps: [
      ["5.1", "Payer pays or denies within 60 calendar days — watch remittances weekly, triage CARC/RARC codes", "Alteva · ECH watches", "SOP 13.1", "Deadline Calendar"],
      ["5.2", "Record the remittance / first-payment (EOB allowable) date — this starts the IDR submission clock", "Ops lane", "SOP 13.1", "Deadline Calendar"],
    ],
  },
  {
    name: "Phase 6 · Open negotiation — PER ALTEVA", window: "Executed by Alteva · ECH verifies", tone: "bd",
    steps: [
      ["6.1", "Alteva initiates open negotiation per the statutory window (miss = no IDR path) — ECH verifies against its own register", "Alteva · ECH verifies", "SOP 13 · Ch 3", "Deadline Calendar (Needs Action Today)"],
      ["6.2", "After the first small payment: 30-DAY window to submit to IDR. Things get missed here — ECH tracks from the day-1 upload to fully-uploaded-to-IDR (Ops lane working closely with Jade at Alteva, using Alteva PowerBI) to keep everything tight and on time", "Ops (Jeff) + Jade/Alteva", "SOP 13.1", "Alteva PowerBI + Deadline Calendar"],
    ],
  },
  {
    name: "Phase 7 · Federal IDR — out of ECH's hands after submission", window: "ECH visibility ends at 7.1 · 90-day check-in flags fire automatically", tone: "bd",
    steps: [
      ["7.1", "SUBMITTED TO IDR — the last date ECH can see until win/loss. The moment this date is recorded, the system starts a recurring 90-DAY POST-SUBMISSION FLAG on the reminders bar (check-in #1 at day 90, #2 at day 180, and so on) — ping Alteva / check PowerBI at each flag", "Alteva submits · ECH records the date", "SOP 13 · Ch 3", "Deadline Calendar (90-day check-in flags)"],
      ["7.2", "Carrier-side response inside IDR — this is the insurance company's step, not ours: ECH CANNOT VERIFY", "Carrier", "Ch 3", "— (not visible to ECH)"],
      ["7.3", "Arbitrator randomly selected by CMS (always random selection) — ECH CANNOT VERIFY", "CMS", "Ch 3", "— (not visible to ECH)"],
      ["7.4", "Offers / materials exchanged with the arbitrator — ECH CANNOT VERIFY", "Alteva ↔ Arbitrator", "Ch 3", "— (not visible to ECH)"],
      ["7.5", "Arbitrator determination (baseball-style) — ECH CANNOT LOG until the win/loss arrives months later; record prevailing party and award when it lands", "Arbitrator", "SOP 14.2", "Deadline Calendar (on arrival)"],
    ],
  },
  {
    name: "Phase 8 · Payment, reconciliation & close", window: "Alteva chases · monthly cycle", tone: "cal",
    steps: [
      ["8.1", "Award payment: at 30 days delinquent, Alteva sends notice to the carrier; at 60 days, Alteva escalates to CMS", "Alteva", "SOP 14.2", "Deadline Calendar"],
      ["8.2", "Cash collected → tie 1:1 to the case log; assist reconciliation invoice approved and paid on cycle (segregation preserved)", "Alteva", "Ch 15", "Case Pipeline (cash gate)"],
      ["8.3", "Fully-awarded IDR payment received → ECH (or the portal) notifies Alteva → Alteva bills ECH 25% + IDR fees of the amount paid out; reconcile against remittance detail, variances resolved in writing", "Finance lane / Alteva", "SOP 13.3 · MOCR C-11", "Alteva Reports (fee variance check)"],
      ["8.4", "Any payer refund demand or credible overpayment → log and clear inside the clock", "Ops lane", "SOP 4.2", "Overpayment 60-Day Log"],
    ],
  },
];

const TONE = { opt: "cleared", ops: "cleared", gate: "open", cal: "cleared", bd: "declined" };

const sopTarget = (ref) => {
  if (/MOCR/i.test(ref)) return "c21";
  const m = ref.match(/(\d{1,2})/);
  return m ? `c${m[1]}` : null;
};
const goToSop = (ref) => {
  const id = sopTarget(ref);
  if (id) window.dispatchEvent(new CustomEvent("ech:navigate", { detail: id }));
};

export default function MasterChecklist({ active }) {
  return (
    <section className={`chapter utility${active === "c11" ? " active" : ""}`} id="mcl">
      <div className="eyebrow">Chapter 11 exhibit · Appendix A-20 reference checklist — relocated into the manual in v1.8-D (no entry fields; the statutory/checklist view of the 12-stage lifecycle above)</div>
      <h1>Claim Processing Master Checklist</h1>
      <p className="lede">The whole flow in business order: case → documentation → the claim-intake determination (Layer 1) → billing handoff → the payer's 60 calendar days → open negotiation and IDR submission, executed by <b>Alteva</b> with ECH verifying — then a dark period where ECH's visibility ends until win/loss. From IDR submission onward the system fires an automatic <b>90-day check-in flag</b> per claim so nothing sits forgotten. SOP references are clickable — tap one to open the cited chapter. Alteva executes; ECH bears the deadline risk and reconciles Alteva's status (ShareFile + PowerBI) against the independent register monthly.</p>

      {PHASES.map((ph) => (
        <div className="formcard" key={ph.name} style={{ marginBottom: 14 }} data-testid={`mcl-${ph.name.slice(6, 7)}`}>
          <div className="formcard-title">{ph.name} <span className={`vr-pill ${TONE[ph.tone]}`}>{ph.window}</span></div>
          <table>
            <tbody>
              <tr><th style={{ width: 40 }}>#</th><th>Step</th><th>Owner</th><th>SOP</th><th>Recorded in</th></tr>
              {ph.steps.map((s) => (
                <tr key={s[0]}>
                  <td className="q">{s[0]}</td>
                  <td>{s[1]}</td>
                  <td>{s[2]}</td>
                  <td className="q">{sopTarget(s[3]) ? <button className="vr-link" onClick={() => goToSop(s[3])} title="Open the cited chapter" data-testid={`mcl-sop-${s[0]}`}>{s[3]}</button> : s[3]}</td>
                  <td>{s[4]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <p style={{ color: "var(--mute)", fontSize: "13px" }}>Standing verification across all phases: independent deadline register per claim reconciled against vendor status reports monthly (MOCR line item); missed-window rate is a standing KPI feeding lender eligibility definitions (standard: zero). Print this page via PRINT/PDF for the working binder — it also ships as a section in the Audit Binder.</p>
    </section>
  );
}
